import { useContext, useEffect, useReducer, useRef } from 'react'
import SystemServerInfoContext from "../contexts/Reference/SystemServierInfo/ServerInfoContext";

const useReferenceServerInfo = () => {
    // Подписка хранит только реально прочитанные компонентом поля Context.
    const store = useContext(SystemServerInfoContext)
    const accessedKeysRef = useRef(new Set())
    const [, forceRender] = useReducer((count) => count + 1, 0)
    const proxyRef = useRef(null)

    if (!store) {
        throw new Error('useReferenceServerInfo должен использоваться внутри SystemServerInfoProvider')
    }

    accessedKeysRef.current.clear()

    if (!proxyRef.current) {
        proxyRef.current = new Proxy({}, {
            get: (target, key) => {
                if (typeof key === 'string') accessedKeysRef.current.add(key)
                return store.getValue(key)
            },
        })
    }

    useEffect(() => store.subscribe((changedKeys) => {
        for (const key of accessedKeysRef.current) {
            if (changedKeys.has(key)) {
                forceRender()
                break
            }
        }
    }), [store])

    return proxyRef.current
};

export default useReferenceServerInfo
